import React, {useContext} from 'react';
import BubbleArrow from "../../BubbleArrow";
import Slider from "react-slick";
import SettingsContext from "../../../contexts/Settings";
import HomeSectionTitle from "../../HomeSectionTitle";
import SlickButtonFix from "../../SlickButtonFix";
import "./Team.scss";

const Member = ({member, className}) => {
	return (
		<div
			className={"team-list__member " + className}
			key={member.imie_i_nazwisko}>
			<img
				src={member.portret}
				alt={"Portret: " + member.imie_i_nazwisko}
				width={285}
				height={385}
			/>
			<div className="team-list__member__info">
				<div>
					<h3>{member.imie_i_nazwisko}</h3>
					<p>{member.stanowisko}</p>
				</div>
				{member.email && <p className="contact">{member.email}</p>}
				{member.tel && <p className="contact">{member.tel}</p>}
			</div>
		</div>
	)
}

const Team = ({sectionTitle, team}) => {
	const {isMobile, isDesktop} = useContext(SettingsContext);

	const teamSliderSettings = {
		dots: false,
		infinite: false,
		initialSlide: 0,
		speed: 800,
		slidesToShow: isMobile ? 1 : 4,
		slidesToScroll: 1,
		easing: "ease-in-out",
		nextArrow: <SlickButtonFix><BubbleArrow size="44px"/></SlickButtonFix>,
		prevArrow: <SlickButtonFix><BubbleArrow size="44px"/></SlickButtonFix>,
	};

	return (
		<div className="team boxed" id="team">
			<div className="row">
				<div className="col col-xs-12 center-xs">
					<HomeSectionTitle text={isMobile ? sectionTitle.mobile : sectionTitle.desktop}/>
				</div>
			</div>
			<div className="row">
				{isDesktop &&
					<div className="col col-xs-12">
						<div className="slider-container">
							<Slider {...teamSliderSettings}>
								{
									team &&
									team.map(member => <Member key={member.imie_i_nazwisko} member={member}/>)
								}
							</Slider>
						</div>
					</div>
				}
				{isMobile && team.map(member => <Member key={member.imie_i_nazwisko} member={member} className="col col-xs-12"/>)}
			</div>
		</div>
	);
};

export default Team;